import React from 'react';
import { Alert, Box, Portal } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import { useTheme } from '@mui/material/styles';

function SimpleAlert({ text, showAlert, type }) {
  const theme = useTheme();

  const getIcon = (type) => {
    if (type === "success") {
      return <CheckIcon fontSize="inherit" />;
    } else {
      return <PersonOffIcon fontSize="inherit" />;
    }
  };

  if (!showAlert) return null;

  return (
    <Portal>
      <Box
        sx={{
          position: 'fixed',
          top: '70px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '70%',
          zIndex: theme.zIndex.snackbar,
          boxShadow: `0 2px 4px ${theme.palette.component.borderColor}`,
        }}
      >
        <Alert icon={getIcon(type)} severity={type === "success" ? "success" : "error"}>
          {text}
        </Alert>
      </Box>
    </Portal>
  );
}

export default SimpleAlert;